import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { PlessJsonDownloadService } from 'src/app/shared/http/pless-json-download.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogService } from '../../../shared/pless-dialog-service';

/**
 * ファイルをダウンロードするサービス
 *
 * @export FileDownloadMultiService
 * @class FileDownloadMultiService
 * @extends {PlessResponder}
 */
@Injectable()
export class FileDownloadMultiService extends PlessJsonDownloadService {

  // 処理に使用するModel
  private filePath = String('');
  private successFunc: Function;

  constructor(
    protected http: HttpClient,
    protected dialogService: PlessDialogService
  ) {
    super(http, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof FileDownloadMultiService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SpecifiedFile: this.filePath
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {string} filePath ファイルパス
   * @memberof FileDownloadMultiService
   */
  execute(filePath: string, fileName: string, successFunc: Function) {
    this.filePath = filePath;
    this.successFunc = successFunc;
    this.send('KYMW02getSpecifiedFile', this.getBody(), String(fileName));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} response レスポンスデータ
   * @memberof GetPlanNumListService
   */
  success(response: any, fileName: string): void {
    if (response !== null) {
      super.success(response, fileName);
      this.successFunc(response);
    }
  }

}
